<template>
    <div class="frame">
        <div class="frame_head">
            <slot name="head"></slot>
        </div>
        <div class="frame_main">
            <slot name="main"></slot>
        </div>
        <div class="frame_foot">
            <slot name="foot"></slot>
        </div>
        <slot name="expand"></slot>
        <GT></GT>
        <Assets></Assets>
    </div>
</template>
<script>
export default {
    
}
</script>
<style lang="scss" scoped>
.frame{
    .frame_foot{
        width:100%;
    }
    .frame_main{
        flex:1;
        min-height: 0;
        width:100%;
        overflow: hidden;
    }
    .frame_head{
        width:100%;
    }
    height:100vh;
    /* Dynamic viewport height: on mobile browsers the URL/toolbar chrome shrinks
       the visible area, but 100vh always resolves to the *largest* viewport. That
       left the bottom of the app (and the inner #view_main scroll area) permanently
       clipped below the fold — e.g. the seat map on the ticket checkout step could
       not be scrolled into view. dvh tracks the actually-visible height. */
    height:100dvh;
    overflow: hidden;
    width: 100%;
    display: flex;
    align-items: center;
    flex-direction: column;
}
</style>